import React from 'react';
import { Typography, Grid, Button, makeStyles } from '@material-ui/core';
import {
    InfoCard,
    Header,
    Page,
    Content,
    ContentHeader,
    HeaderLabel,
    SupportButton,
    Link,
} from '@backstage/core-components';

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(4),
    },
    button: {
        margin: theme.spacing(1),
    },
    cardContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
    },
    documentationLink: {
        fontWeight: 'bold',
        textDecoration: 'underline',
        color: theme.palette.primary.main,
    },
}));

export const PulseHubPage = () => {
    const classes = useStyles();

    const downloads = [
        { label: 'Windows', url: 'https://gmstaticdocs.azureedge.net/pulse-hub/pulse_hub_setup.exe', os: 'win' },
        { label: 'Linux', url: 'https://gmstaticdocs.azureedge.net/pulse-hub/PulseHub-x86_64%202.appimage', os: 'linux' },
        { label: 'macOS', url: '#', os: 'mac' },
    ];

    return (
        <Page themeId="tool">
            <Header title="Pulse Hub" subtitle="Central de Downloads e Informações">
                <HeaderLabel label="Owner" value="ARKA" />
                <HeaderLabel label="Lifecycle" value="Beta" />
            </Header>
            <Content>
                <ContentHeader title="Downloads">
                    <SupportButton>A place to download necessary tools.</SupportButton>
                </ContentHeader>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <InfoCard title="Sobre o Pulse Hub">
                            <Typography variant="body1">
                                Ferramenta que facilita a execução de containers Docker localmente, fornecendo maior agilidade no processo de desenvolvimento.
                            </Typography>
                        </InfoCard>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <InfoCard title="Documentação">
                            <Typography variant="body1">
                                Em caso de dúvidas na instalação do componente ou execução, consulte a <Link className={classes.documentationLink} to="https://grupomateus.atlassian.net/wiki/spaces/DT/pages/2379841617/Pulse+Hub+-+Guia+do+Usu+rio">Documentação do Projeto</Link>. Se necessário, entre em contato com o time da Arquitetura/Engenharia.
                            </Typography>
                        </InfoCard>
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <InfoCard title="Baixar Executáveis">
                            <div className={classes.cardContent}>
                                <Typography variant="body2" paragraph>
                                    Selecione o seu sistema operacional:
                                </Typography>
                                <div>
                                    {downloads.map(d => (
                                        <Button
                                            key={d.os}
                                            variant="contained"
                                            color="primary"
                                            href={d.url}
                                            className={classes.button}
                                        >
                                            Download para {d.label}
                                        </Button>
                                    ))}
                                </div>
                            </div>
                        </InfoCard>
                    </Grid>
                </Grid>
            </Content>
        </Page>
    );
};
